var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      verticalAlign: "sub"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 12.25V11.0833C11.6665 10.4645 11.4207 9.871 10.9831 9.43342C10.5455 8.99583 9.95203 8.75 9.33319 8.75H4.66652C4.04769 8.75 3.45419 8.99583 3.01661 9.43342C2.57902 9.871 2.33319 10.4645 2.33319 11.0833V12.25",
    stroke: "#727374",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00014 6.41667C8.28881 6.41667 9.33347 5.372 9.33347 4.08333C9.33347 2.79467 8.28881 1.75 7.00014 1.75C5.71148 1.75 4.66681 2.79467 4.66681 4.08333C4.66681 5.372 5.71148 6.41667 7.00014 6.41667Z",
    stroke: "#727374",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.f6884adb.svg";
export { ForwardRef as ReactComponent };